import {Enum} from 'enumify';

export default class ServiceType extends Enum {
}
ServiceType.initEnum({
  RAPAEL_CLINIC: {
    get title() {
      return 'Rapael Clinic';
    },
  },
  RAPAEL_CLINIC2: {
    get title() {
      return 'Rapael Clinic2';
    },
  },
  RAPAEL_HOME: {
    get title() {
      return 'Rapael Home';
    },
  },
  COMCOG: {
    get title() {
      return 'ComCog';
    },
  },
  COMCOG_ADMIN: {
    get title() {
      return 'ComCog Admin';
    },
  },
  COMCOG_PUBLIC: {
    get title() {
      return 'ComCog Public';
    },
  },
  SMART_COACH: {
    get title() {
      return 'Smart Coach';
    },
  },
  SMART_CARE: {
    get title() {
      return 'Smart Care';
    },
  },

  SMART_TABLE: {
    get title() {
      return 'Smart Table';
    },
  },

  B1: {
    get title() {
      return 'B1 Sling';
    },
  },

  B2: {
    get title() {
      return 'B2 Video Analysis';
    },
  },
  SMART_BODY_CHECKER: {
    get title() {
      return 'Smart Body Checker';
    }
  }
});



// WEBPACK FOOTER //
// ./src/constants/ServiceType.js